/* w9-card-swatches — hover/focus a colour dot to preview that variant's photo on the card (2026-09-23).
   2026-10-25: also the W9 collection page's cards (.w9c__item, photo in .w9c__media). */
(function () {
  if (window.__w9sw) return; window.__w9sw = 1;
  function img(dot) {
    var card = dot.closest('.card-product, .card, .w9c__item');
    return card ? card.querySelector('.card-media img, .w9c__media img') : null;
  }
  function show(dot) {
    var el = img(dot), src = dot.getAttribute('data-img');
    if (!el || !src) return;
    if (el.dataset.w9Src === undefined) { el.dataset.w9Src = el.getAttribute('src') || ''; el.dataset.w9Srcset = el.getAttribute('srcset') || ''; }
    el.removeAttribute('srcset'); el.setAttribute('src', src);
  }
  function restore(dot) {
    var el = img(dot);
    if (!el || el.dataset.w9Src === undefined) return;
    el.setAttribute('src', el.dataset.w9Src);
    if (el.dataset.w9Srcset) el.setAttribute('srcset', el.dataset.w9Srcset);
  }
  function dot(e) { return e.target && e.target.closest ? e.target.closest('.w9-sw__dot[data-img]') : null; }
  document.addEventListener('mouseover', function (e) { var d = dot(e); if (d) show(d); });
  document.addEventListener('mouseout', function (e) { var d = dot(e); if (d) restore(d); });
  document.addEventListener('focusin', function (e) { var d = dot(e); if (d) show(d); });
  document.addEventListener('focusout', function (e) { var d = dot(e); if (d) restore(d); });
})();